import React, { Component } from "react"
import { Link } from 'react-router-dom'
import Carousel from "react-slick"
import axios from 'axios'
import {BACKEND_IP} from '../constants/backendIp'
import { makeStyles, useTheme } from "@material-ui/core/styles"
import LocationOn from "@material-ui/icons/LocationOn"
import Button from '@material-ui/core/Button'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import AddIcon from '@material-ui/icons/Add'
import GridContainer from "../components/Grid/GridContainer"
import GridItem from "../components/Grid/GridItem"
import Card from "../components/Card/Card"
import logo from '../assets/img/homeDeliveryLogo.png'
import styles from "../assets/jss/material-kit-react/views/componentsSections/carouselStyle";
import { container } from "../assets/jss/material-kit-react"

const useStyles = makeStyles(theme => ({
  item: {
    [theme.breakpoints.down('sm')]: {
      flexFlow:'column'
    },
    [theme.breakpoints.up('md')]: {
      flexFlow:'row'
    },
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
  },
  itemHeader: {
    [theme.breakpoints.down('xs')]: {
      fontSize:11
    },
    [theme.breakpoints.up('sm')]: {
      fontSize:14
    },
    [theme.breakpoints.up('md')]: {
      fontSize:18
    },
    display:'flex',
    justifyContent:'center',
    height:25,
    width:'100%',
    paddingTop:6,
    backgroundColor:'black',
    color:'green',
    fontWeight:'bold'
  },
  image: {
    [theme.breakpoints.down('xs')]: {
      maxHeight:'145px',
      minHeight:'145px',
      alignSelf:'center'
    },
    [theme.breakpoints.up('sm')]: {
      maxHeight:'176px',
      minHeight:'176px'
    },
    width:'100%'
  },
  carousel: {
    [theme.breakpoints.down('sm')]: {
      width:'100vw'
    },
    [theme.breakpoints.up('md')]: {
      width:'100vw'
    },
    height:'auto',
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
  }
}));

export default function Item(props) {
  const classes = useStyles();
  const [autoplay, setAutoplay] = React.useState(false);
  const [itemId, setItemId] = React.useState("");
  const theme = useTheme();
  let media = useMediaQuery(theme.breakpoints.up('sm'));

  const settings = {
    dots: media,
    infinite: true,
    speed: 500,
    slidesToShow: media ? 4 : 3,
    slidesToScroll: 1,
    autoplay: false
  };

  const carouselExample = () => {
    return (
      <div className={classes.item}>
        <GridContainer className={classes.carousel}>
          <GridItem >
            <Card carousel>
              <Carousel {...settings}>
                <Link to={'/item/5ddb456fe5e8b8782e06e8f9'} href="#top">
                  <div>
                    <div className={classes.itemHeader}>
                      Liberty Haze
                    </div>
                    <img src={BACKEND_IP+"/5ddb456fe5e8b8782e06e8f9"}
                      style={{height:'100%'}}
                      alt="First slide" className={classes.image}/>
                  </div>
                </Link>
                <Link to={'/item/5ddb456fe5e8b8782e06e8fa'} href="#top">
                  <div>
                    <div className={classes.itemHeader}>
                      Laughing Buddha
                    </div>
                  <img src={BACKEND_IP+"/5ddb456fe5e8b8782e06e8fa"}
                      alt="Second slide" className={classes.image}/>
                  </div>
                </Link>
                <Link to={'/item/5ddb456fe5e8b8782e06e8fb'} href="#top">
                  <div>
                    <div className={classes.itemHeader}>
                      Blue Dream Sour Jack
                    </div>
                    <img src={BACKEND_IP+"/5ddb456fe5e8b8782e06e8fb"}
                      style={{backgroundSize:'cover'}}
                      alt="Third slide" className={classes.image}/>
                  </div>
                </Link>
                <Link to={'/item/5ddb456fe5e8b8782e06e8f7'} href="#top">
                  <div>
                    <div className={classes.itemHeader}>
                      Dr. Green Thumb
                    </div>
                    <img src={BACKEND_IP+"/5ddb456fe5e8b8782e06e8f7"}
                      alt="Fourth slide" className={classes.image}/>
                  </div>
                </Link>
                <Link to={'/item/5ddb4573e5e8b8782e06e904'} href="#top">
                  <div>
                    <div className={classes.itemHeader}>
                      Glookies
                    </div>
                    <img src={BACKEND_IP+"/5ddb4573e5e8b8782e06e904"}
                      alt="Fifth slide" className={classes.image}/>
                  </div>
                </Link>
                <Link to={'/item/5ddb456fe5e8b8782e06e8fd'} href="#top">
                  <div>
                    <div className={classes.itemHeader}>
                      Mountain Temple
                    </div>
                    <img src={BACKEND_IP+"/5ddb456fe5e8b8782e06e8fd"}
                      alt="Sixth slide" className={classes.image}/>
                  </div>
                </Link>
                <Link to={'/item/5ddb4573e5e8b8782e06e903'} href="#top">
                  <div>
                    <div className={classes.itemHeader}>
                      L$D
                    </div>
                    <img src={BACKEND_IP+"/5ddb4573e5e8b8782e06e903"}
                      alt="Seventh slide" className={classes.image}/>
                  </div>
                </Link>
              </Carousel>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }

  return (
    <div style={{backgroundColor: "#2d2f2d",minHeight:'100vh'}}>
      <div style={{backgroundColor: "black",height:'100px',
        display:'flex',flexFlow:'row',alignItems:'flex-end'}}>
        <div style={{fontSize:'6vw',color:'white',display:'flex',alignSelf:'center'}}>
          Bailey's Buds
        </div>
        <div style={{color: 'white',fontSize: '36px',
          fontFamily:'Raleway',margin:6}}>

        </div>
      </div>
      <div style={{display:'flex',justifyContent:'flex-start',
        marginLeft:'2vw',paddingTop:'40px'}}>
        <div style={{color: 'white',fontSize: '22px',
          fontFamily:'Raleway'}}>
          Best Sellers:
        </div>
      </div>
      {carouselExample()}
      <div style={{display:'flex',justifyContent:'flex-start',
        marginLeft:'2vw'}}>
        <div style={{color: 'white',fontSize: '22px',
          fontFamily:'Raleway'}}>
          Staff Picks:
        </div>
      </div>
      {carouselExample()}
      <div style={{display:'flex',justifyContent:'flex-start',
        marginLeft:'2vw'}}>
        <div style={{color: 'white',fontSize: '22px',
          fontFamily:'Raleway'}}>
          Sponsored:
        </div>
      </div>
      {carouselExample()}
    </div>
  );
}
